<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark py-3 shadow" aria-label="Tenth navbar example">
    <div class="container-fluid">
      <a class="navbar-brand fw-bold text-uppercase" href="#">Eurekali Admin</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarExample"
        aria-controls="navbarExample" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-center" id="navbarExample">
        <ul class="navbar-nav text-center">
          <!-- Shipments Dropdown -->
          <li class="nav-item dropdown" :class="{ active: isShipmentsActive }">
            <a class="nav-link dropdown-toggle" href="#" id="shipmentsDropdown" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              Shipments
            </a>
            <ul class="dropdown-menu" aria-labelledby="shipmentsDropdown">
              <li><router-link class="dropdown-item" to="/shipments-progress">Accepted</router-link></li>
              <li><router-link class="dropdown-item" to="/shipments-pending">Pending</router-link></li>
              <li><router-link class="dropdown-item" to="/shipments-delivered">Delivered</router-link></li>
              <li><hr class="dropdown-divider"></li>
              <li><router-link class="dropdown-item" to="/historique-annulations">Historique des actions</router-link></li>
            </ul>
          </li>

          <!-- Accounting Dropdown -->
          <li class="nav-item dropdown" :class="{ active: isAccountingActive }">
            <a class="nav-link dropdown-toggle" href="#" id="accountingDropdown" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              Accounting
            </a>
            <ul class="dropdown-menu" aria-labelledby="accountingDropdown">
              <li><router-link class="dropdown-item" to="/invoices">Factures</router-link></li>
              <li><router-link class="dropdown-item" to="/auto-facturations">Auto facturations</router-link></li>
              <li><router-link class="dropdown-item" to="/refunds">Remboursements</router-link></li>
              <li><router-link class="dropdown-item" to="/cash-payments">Cash payments</router-link></li>
              <li><router-link class="dropdown-item" to="/reports">Rapports</router-link></li>
            </ul>
          </li>

          <li class="nav-item">
            <router-link to="/users" :class="['nav-link', isActive('/users') ? 'active' : '']">Users</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/service-points" :class="['nav-link', isActive('/service-points') ? 'active' : '']">Service Points</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/statistics" :class="['nav-link', isActive('/statistics') ? 'active' : '']">Statistics</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/transporters" :class="['nav-link', isActive('/transporters') ? 'active' : '']">Transporters</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/clients" :class="['nav-link', isActive('/clients') ? 'active' : '']">Clients</router-link>
          </li>
          <li v-if="canSeeCashAlerts" class="nav-item">
            <router-link to="/cash-alerts" :class="['nav-link', isActive('/cash-alerts') ? 'active' : '']">
              Alertes cash
              <span v-if="unreadCashAlerts" class="badge rounded-pill bg-danger ms-1">{{ unreadCashAlerts }}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/security" :class="['nav-link', isActive('/security') ? 'active' : '']">Securite</router-link>
          </li>
          <li class="nav-item">
            <button class="btn btn-outline-danger ms-lg-3" @click="logout()">Log Out</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>





<script>
import axios from 'axios'
import en from '../en.js';
import fr from '../fr.js';
import nl from '../nl.js';



export default {
  mixins: [en, fr, nl],
  data() {
    return {
      orders: [],
      lang: this.$store.state.lang,
      unreadCashAlerts: 0,
      canSeeCashAlerts: false,
    }
  },
  computed: {
    lang2() {
      return this.$store.state.lang
    },
    isShipmentsActive() {
    return ['/shipments-progress', '/shipments-pending', '/shipments-delivered', '/historique-annulations'].includes(this.$route.path);
  },
  isAccountingActive() {
    return ['/invoices', '/refunds', '/auto-facturations', '/reports', '/cash-payments'].includes(this.$route.path);
  }
  },
  mounted() {
    const language = navigator.language.split('-')[0];
    const supportedLanguages = ['en', 'fr', 'nl'];

    if (supportedLanguages.includes(language)) {
      this.lang = language;
    } else {
      this.lang = 'en';
    }

    this.updateLang()
    this.refreshCashAlerts()
    this.cashAlertTimer = window.setInterval(this.refreshCashAlerts, 60000)

  },
  beforeUnmount() {
    if (this.cashAlertTimer) window.clearInterval(this.cashAlertTimer)
  },
  methods: {
    translate(prop) {
      return this[this.lang2][prop];
    },
    updateLang() {
      this.$store.commit('setLang', this.lang);
    },
    isActive(route) {
      return this.$route.path === route;
    },
    async refreshCashAlerts() {
      try {
        const { data } = await axios.get('/api/v1/admin/cash-alerts/')
        this.canSeeCashAlerts = true
        this.unreadCashAlerts = data.unread_count || 0
      } catch (error) {
        this.canSeeCashAlerts = false
        this.unreadCashAlerts = 0
      }
    },
    logout() {
      axios.defaults.headers.common["Authorization"] = ""
      sessionStorage.removeItem("token")
      this.$store.commit('removeToken')
      this.$store.commit('clearShipment')
      this.$router.push('/login')
    }
  }
}
</script>


<style>
.nav-link {
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff !important;
  margin: 0 8px;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
  border-radius: 5px;
}


.nav-link:hover {
  background-color: #495057;
  color: #E5097F !important;
}

/* Active link styling */
.nav-link.active {
  background-color: #E5097F !important;
  color: #fff !important;
  border-radius: 5px;
}

/* Button styles */
.btn-outline-danger {
  font-size: 0.9rem;
  padding: 4px 10px;
  border-width: 2px;
  transition: all 0.3s ease-in-out;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  color: #ffffff;
}

.nav-item.active > .nav-link {
  background-color: #E5097F !important;
  color: #fff !important;
  border-radius: 5px;
}

</style>
